
import React from 'react';
import { Button } from '@/components/ui/button';
import { List, Map } from 'lucide-react';

interface ViewToggleProps {
  currentView: 'list' | 'map';
  onViewChange: (view: 'list' | 'map') => void;
  disabled?: boolean;
}

const ViewToggle = ({ currentView, onViewChange, disabled }: ViewToggleProps) => {
  return (
    <div className="flex bg-gray-100 rounded-lg p-1">
      <Button
        variant={currentView === 'list' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('list')}
        disabled={disabled}
        className={`flex items-center gap-2 rounded-md px-3 py-2 ${
          currentView === 'list' ? 'shadow-sm' : ''
        }`}
      >
        <List className="h-4 w-4" />
        List
      </Button>
      <Button
        variant={currentView === 'map' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('map')}
        disabled={disabled}
        className={`flex items-center gap-2 rounded-md px-3 py-2 ${
          currentView === 'map' ? 'shadow-sm' : ''
        }`}
      >
        <Map className="h-4 w-4" />
        Map
      </Button>
    </div>
  );
};

export default ViewToggle;
